import {
  ChemistryReactionRole,
  CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM,
} from 'notebook/integrations/chemistry/ChemistryStructuredTableConstants';
import {
  StructuredTableColumnGroups,
  StructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {BaseTypedValueType} from 'notebook/tables/TableConstants';

export function getMoleculeIdFromEvaluatedCell(cell: EvaluatedCell): string | null {
  if (cell.value?.type === BaseTypedValueType.BIOENTITY && cell.value.bioentitySummary?.id) {
    return cell.value.bioentitySummary.id;
  }
  return null;
}

export function getRoleFromEvaluatedCell(cell: EvaluatedCell): ChemistryReactionRole | null {
  if (cell.value?.type === BaseTypedValueType.STRING && cell.value.rawValue) {
    if (CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM[cell.value.rawValue]) {
      return CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM[cell.value.rawValue]!;
    }
  }
  return null;
}

export function getColumnIndices(columns: Array<StructuredTableColumn>): {
  compoundColumnIndex: number;
  roleColumnIndex: number;
} {
  const compoundColumnIndex = columns.findIndex(
    (col) => col.columnGroup === StructuredTableColumnGroups.CHEMISTRY_MOLECULE
  );
  const roleColumnIndex = columns.findIndex(
    (col) => col.columnGroup === StructuredTableColumnGroups.CHEMISTRY_REACTION_ROLE
  );

  if (compoundColumnIndex === -1 || roleColumnIndex === -1) {
    throw new Error('Could not find required columns');
  }
  return {compoundColumnIndex, roleColumnIndex};
}
